import styled from "styled-components";

import {getTheme} from "../../../shared/themeUtils";

const ProductCardContain = styled.div`
  min-height: 160px;
  border: 1px solid ${getTheme("colors.border")};
  padding: ${getTheme("space.2")};
  margin: ${getTheme("space.2")} 0;
  border-radius: ${getTheme("borderRadius")};
  display: flex;
  position: relative;

  .image-section {
    width: 120px;
    margin-right: ${getTheme("space.3")};
    display: flex;
    justify-content: center;
    align-items: center;

    .img-placeholder {
      height: 100%;
      width: 100%;
      max-width: 120px;
      max-height: 120px;
    }
  }
`

const PriceSection = styled.div`
  margin-left: auto;
  min-width: 160px;
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;

  .currency-price {
    font-weight: bold;
    font-size: ${getTheme("fontSizes.xLarge")};
  }

  .list-price {
    color: ${getTheme("colors.secondaryFont")};
    font-size: ${getTheme("fontSizes.medium")};
  }

  .actions {
    display: flex;
    flex-direction: row;

    button {
      margin-left: 10px;
    }
  }
`

const InfoSection = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .card-title {
    font-size: ${getTheme("fontSizes.large")};

    .brand-name {
      font-weight: 700;
    }
  }

  .top-properties {
    ul {
      padding: 0;
      margin: 0;

      li {
        list-style: none;
        display: flex;
        align-items: center;
        height: 20px;
        margin-bottom: ${getTheme("space.1")};

        span {
          margin-left: 5px;
        }
      }
    }
  }
`

const ProductListingPlaceholder = () => {
  return (
    <ProductCardContain>
      <div className="image-section placeholder-wave">
        <div className="img-placeholder placeholder"></div>
      </div>

      <InfoSection className="placeholder-wave w-50">
        <div className="card-title placeholder col-12">
          Title
        </div>
        <div className="top-properties">
          <ul>
            <li className="placeholder col-6 small"></li>
            <li className="placeholder col-6 small"></li>
            <li className="placeholder col-6 small"></li>
          </ul>
        </div>
      </InfoSection>

      <PriceSection>
        <div className="price placeholder-wave">
          <div className="currency-price placeholder">
            Price
          </div>
        </div>
      </PriceSection>
    </ProductCardContain>
  )
}
export default ProductListingPlaceholder
